<div class="cs-header">
  <h2 class="cs-title">
    {{
      'operations.compileStat.pickTitle'
        | translate
          : {
              stat:
                statLabel() ||
                ('operations.compileStat.genericStat' | translate)
            }
    }}
  </h2>
  @if (operationName()) {
  <ion-note color="medium" class="cs-subtitle">{{
    'operations.compileStat.forOperation'
      | translate: { name: operationName() }
  }}</ion-note>
  }
  @if (statHint()) {
  <ion-note class="cs-hint">{{ statHint() }}</ion-note>
  }
</div>
<ion-list lines="none" class="so-list re-card-list">
  <ion-list-header>{{ 'operations.compileStat.header' | translate }}</ion-list-header>
  @for (stat of list(); track stat.id) {
  <ion-item button (click)="selectStat(stat)">
    <ion-label>
      <h2 class="re-list-row-title">{{ stat.name }}</h2>
    </ion-label>
  </ion-item>
  }
</ion-list>
